import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import isEqual from 'lodash-es/isEqual.js';
import omit from 'lodash-es/omit.js';

@Service('ib-web-ancillaries-module',
    ['localStorageService', 'DatalayerConstants', 'AncillariesConstants'],
    ['ib-commons-constants-module', 'ib-monetate-module'])
export class DatalayerHelper {
    seatSelectedId: string[] = [];
    seatSelectedType: string[] = [];
    segmentId: string;
    constructor (
        private localStorageService: angular.local.storage.ILocalStorageService,
        private DatalayerConstants: DatalayerConstantsType,
        private AncillariesConstants: AncillariesConstant
    ) { }

    getBrandItem = (origin: string, idOrigin: any): string => {
        const flowApp = this.localStorageService.get('flowApp');
        const isSeatMap = (origin === '' && idOrigin === null);
        let brandItem: string = '';
        switch (flowApp) {
                case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                    const segmentsSelected: any = this.localStorageService.get('segmentsSelected');
                    let idSeg = '';
                    if (!isSeatMap) {
                        const splitId: string[] = idOrigin?.toString().split('_') || [];
                        const isSliceId: boolean = (splitId.length > 0 && splitId.length === 2);
                        const ancillariesInfo: any = this.localStorageService.get('ancillariesInfo');
                        if (segmentsSelected.length > 0) {
                            if (isSliceId && ancillariesInfo?.slices?.length > 0) {
                                ancillariesInfo.slices.forEach(slice => {
                                    if (idOrigin === slice?.id && slice?.segmentIds?.length > 0) {
                                        idSeg = slice.segmentIds[0];
                                    }
                                });
                            } else {
                                idSeg = idOrigin;
                            }
                        }
                    } else {
                        const seatMap: any = this.localStorageService.get('seatMapSegment');
                        idSeg = seatMap?.segmentId?.toString();
                    }

                    for (let i = 0; i < segmentsSelected.length; i++) {
                        const segSelected = segmentsSelected[i];
                        const originSelected: string = `${segSelected?.departure?.airportCode}-${segSelected?.arrival?.airportCode}`;
                        if (+segSelected?.id === +idSeg || origin === originSelected) {
                            brandItem = segSelected.airlineName;
                        }
                    }
                    break;

                default:
                // BKI MMB
                    const selectedTripInfo: any = this.localStorageService.get('selectedTripInfo');
                    const flightsInfo: any = this.localStorageService.get('flightsInfo');
                    if (selectedTripInfo) {
                        if (selectedTripInfo.length > 1 && origin !== selectedTripInfo[0].origin) {
                            brandItem = selectedTripInfo[1].info.segments[0].flight.operationalCarrier.name.toLowerCase();
                        } else {
                            brandItem = selectedTripInfo[0].info.segments[0].flight.operationalCarrier.name.toLowerCase();
                        }
                    } else if (flightsInfo) {
                        if (flightsInfo.length > 1 && origin !== flightsInfo[0]?.departure?.code) {
                            brandItem = flightsInfo[1].flight.operationalCarrier.name.toLowerCase();
                        } else {
                            brandItem = flightsInfo[0].flight.operationalCarrier.name.toLowerCase();
                        }
                    }
                    break;
        }

        return brandItem;
    };
    getItemCategory = (): string => {
        const flowApp = this.localStorageService.get('flowApp');
        const isHMAD = this.localStorageService.get('isHMAD');
        const isMultipleTrip = this.localStorageService.get('multiCitySearch');
        const isMetasearch = this.localStorageService.get('searchFlightType') === this.AncillariesConstants.FLOW_TYPE.METASEARCH;

        if(flowApp === this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            return 'mmb';
        }else if(flowApp === this.AncillariesConstants.APPLICATION_FLOW.CHECKIN ) {
            return 'checkin';
        } else {
            if(isMetasearch) return this.AncillariesConstants.ECOMMERCE.METASEARCH;
            if(isHMAD) return this.AncillariesConstants.ECOMMERCE.STOPOVER_HMAD;
            if(isMultipleTrip) return this.AncillariesConstants.ECOMMERCE.MULTIPLE_JOURNEYS;
            return this.DatalayerConstants.DATALAYER_VALUES.PURCHASE_CATEGORY.DIRECT.toLowerCase();
        }
    };

    ecommerceFlowCKI = (item: DigitalDataEcommerceModel.Item, idModel: string, piece?: any): DigitalDataEcommerceModel.Item => {
        const flowApp = this.localStorageService.get('flowApp');
        if (flowApp === this.AncillariesConstants.APPLICATION_FLOW.CHECKIN) {
            const segmentsSelected: any = this.localStorageService.get('segmentsSelected');
            const ancillariesSlices: any = this.localStorageService.get('ancillariesSlices');
            let objSegmentIds: any = null;
            let airlineName: string = 'Iberia';
            let positionSlice: string = '';
            ancillariesSlices.forEach((elem, i) => {
                if (elem.id === idModel) {
                    positionSlice = (i + 1).toString();
                    objSegmentIds = elem;
                }
            });

            segmentsSelected.forEach((seg, i) => {
                if (objSegmentIds && seg.id === Number(objSegmentIds.segmentIds[0])) {
                    if (seg.airlineName?.length > 0) {
                        airlineName = seg.airlineName;
                    } else if (seg.flightCode?.length > 0) {
                        airlineName = seg.flightCode;
                    }

                    if (seg.departure?.airportCode && seg.arrival?.airportCode) {
                        item.item_category2 = `${seg.departure.airportCode}-${seg.arrival.airportCode}`;
                        item.item_category3 = positionSlice;
                    }
                }
            });

            if (item.item_category3 === 'all') {
                const arrId = item.item_id.split('|');
                arrId.forEach((element, i) => {
                    if (item.item_category2 === element) {
                        item.item_category3 = (i + 1).toString();
                    }
                });
            }

            if (piece?.availablePriceRanges[0]?.amount) {
                item.price = piece.availablePriceRanges[0].amount;
            }

            item.item_category = 'checkin';
            item.quantity = (item?.quantity && item.quantity > 0) ? item.quantity : 1;
            item.item_brand = airlineName;
        }

        return item;
    };

    getBaggagePrice = (piece: any): number => {
        let price = 0;
        piece.availablePriceRanges.forEach(range => {
            if (piece.quantySelected >= range.from && piece.quantySelected <= range.to) {
                price = range.amount;
            }
        });
        return price;
    };
    getItemsToAddOrRemove = (addToCart: DigitalDataEcommerceModel.ViewItemList, digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList, isToAdd: boolean): DigitalDataEcommerceModel.ViewItemList => {

        const itemsRecovered: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const dataToSearch = isToAdd ? digital_data_ecommerce : addToCart;
        const dataToCompare = isToAdd ? addToCart : digital_data_ecommerce;

        dataToSearch.items.forEach(itemAddToCart => {
            const indexAddToCart = dataToCompare.items.findIndex(item => isEqual(omit(itemAddToCart, ['quantity']), omit(item, ['quantity'])));
            if (indexAddToCart < 0) {
                itemsRecovered.items.push(itemAddToCart);
            } else if (indexAddToCart >= 0 && itemAddToCart.quantity > dataToCompare.items[indexAddToCart].quantity) {
                const modItemAddToCart = structuredClone(itemAddToCart);
                modItemAddToCart.quantity = modItemAddToCart.quantity - dataToCompare.items[indexAddToCart].quantity;
                itemsRecovered.items.push(modItemAddToCart);
            }
        });


        return itemsRecovered;
    };

    getItemAddToCartByItemName = (itemName: string): DigitalDataEcommerceModel.ViewItemList => {
        const viewItemList: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const addToCart: any = this.localStorageService.get('addToCart') || { ecommerce: { items: [] } };
        addToCart.ecommerce.items.forEach(itemAddToCart => {
            if (itemAddToCart.item_name === itemName) {
                viewItemList.items.push(itemAddToCart);
            }
        });
        return viewItemList;
    };
}

